import { verifyPassport } from '@/api';
import { routes } from '@/constant/routes.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { TranslationZone } from '@/styles';
import { IVerifyPassportPayload } from '@/types/common.type';
import { Faq } from '@repo/components';
import { STORE_FAQ } from '@repo/constants';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

const FaqPage = () => {
  const { passportNumber, nationality } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const history = useHistory();
  const loginToken = localStorage.getItem('login');
  const LANG = nationality === 'KOR' ? 'KOR' : 'ENG';

  const { mutate: verifyPassportMutation } = useMutation(
    (payload: IVerifyPassportPayload) => verifyPassport(payload),
    {
      onSuccess: (res) => {
        const { email } = res;
        if (!email) {
          return history.push(routes.inquiryEmail);
        }
        history.push(routes.inquiryQna);
      },
      onError: (res: any) => {
        alert(res.data.message);
      },
    },
  );

  const startInquiry = () => {
    if (!loginToken || !passportNumber) {
      return history.push(routes.inquiryPassport);
    }
    verifyPassportMutation({ passportNumber });
  };

  return (
    <>
      <TranslationZone />
      <Faq
        faqList={STORE_FAQ[LANG]}
        onBackPage={() => history.goBack()}
        onInquiry={startInquiry}
        lang={LANG}
      />
    </>
  );
};
export default FaqPage;
